<template>
  <div id="contenedor-componente-main-menu">
    <v-navigation-drawer v-model="mostrar" app dark color="primary">
      <v-list dark dense nav>
        <v-list-item>
          <v-row
            no-gutters
            justify="center"
            align="center">
            <v-img
              src="@/assets/sideop-png.png"
              height="60"
              max-width="150"
              contain>
            </v-img>
          </v-row>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
        <template v-for="(ruta, index) in rutas">
          <!-- Si no tine hijos -->
          <v-list-item :disabled="usuarioTieneScopes(ruta.scopes)"
            v-if="ruta.children.length <= 0"
            :key="`${ruta.ruta}-${index}`"
            :to="{ name: ruta.ruta }">
            <v-list-item-icon v-if="ruta.icono">
              <v-icon>{{ ruta.icono }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ ruta.nombre }}
              </v-list-item-title>
              <v-list-item-action class="pa-0 ma-0">
                <v-badge
                  v-if="ruta.contadorQuery && obtenerNumeroContratosConObservaciones()"
                  inline
                  color="warning"
                  :content="obtenerNumeroContratosConObservaciones()">
                </v-badge>
              </v-list-item-action>
          </v-list-item>
          <!-- Si tiene hijos [primer nivel] -->
          <v-list-group
            active-class="white--text"
            v-if="ruta.children.length > 0"
            :value="false"
            :key="`sub-menu-${ruta.ruta}-${index}`"
            :prepend-icon="ruta.icono">
            <template v-slot:activator>
              <v-list-item-title>{{ ruta.nombre }}</v-list-item-title>
            </template>
            <!-- Los hijos [del primer nivel]  -->
            <template v-for="(ruta, index) in ruta.children">
              <!-- Si no tiene hijos [] -->
              <v-list-item :disabled="usuarioTieneScopes(ruta.scopes)"
                active-class="white--text"
                v-if="ruta.children.length <= 0"
                :key="`${ruta.ruta}-${index}`"
                :to="{ name: ruta.ruta }"
                class="ml-3">
                <v-list-item-icon v-if="ruta.icono">
                  <v-icon dense>{{ ruta.icono }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ ruta.nombre }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <!-- Si tiene hijos [segundo nivel] -->
              <v-list-group
                active-class="white--text"
                v-if="ruta.children.length > 0"
                no-action
                sub-group
                :key="`sub-menu-${ruta.ruta}-${index}`">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ ruta.nombre }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <!-- Mostrar los hijos [segundo nivel] -->
                <!-- <template> -->
                <v-list-item :disabled="usuarioTieneScopes(ruta.scopes)"
                  v-for="(ruta, index) in ruta.children"
                  active-class="white--text"
                  :key="`${ruta.ruta}-${index}`"
                  :to="{ name: ruta.ruta }"
                >
                  <v-list-item-title>{{ ruta.nombre }}</v-list-item-title>
                </v-list-item>
                <!-- </template> -->
              </v-list-group>
            </template>
          </v-list-group>
          <!-- Divisor -->
          <v-divider v-if="ruta.divisor" :key="`divisor-${index}`" class="my-1"></v-divider>
        </template>
      </v-list>
      <template
        v-slot:append>
        <v-list-item
          :to="{ name: 'logout' }">
          <v-list-item-icon>
            <v-icon>
              mdi-logout
            </v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            Salir
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import GET_CONTRATOS_CON_OBSERVACIONES from '@/graphql/querys/administracion/auditorias/getNumberContratosWithObservacionesActivas.gql';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'componenteMainMenu',
  data() {
    return {
      mostrar: true,
      // usuarioScopes: [],
      rutas: [
        {
          ruta: 'configuracion',
          nombre: 'Configuración',
          scopes: 'Configuración:ver',
          icono: 'mdi-cog',
          divisor: true,
          children: [
            {
              ruta: 'catalogos',
              nombre: 'Catálogos',
              scopes: 'Catálogos:ver',
              icono: '',
              children: [
                {
                  ruta: 'catalogoEntidades',
                  nombre: 'Entidades',
                  scopes: 'Catálogos:ver',
                  icono: 'mdi-folder-download-outline',
                  divisor: false,
                  children: [],
                },
                {
                  ruta: 'catalogoMunicipios',
                  nombre: 'Municipios',
                  scopes: 'Catálogos:ver',
                  icono: 'mdi-folder-download-outline',
                  divisor: false,
                  children: [],
                },
                {
                  ruta: 'catalogoContratistas',
                  nombre: 'Contratistas',
                  scopes: 'Catálogos:ver',
                  icono: 'mdi-folder-download-outline',
                  divisor: false,
                  children: [],
                },
                {
                  ruta: 'catalogoDeducciones',
                  nombre: 'Deducciones',
                  scopes: 'Catálogos:ver',
                  icono: 'mdi-folder-download-outline',
                  divisor: false,
                  children: [],
                },
                {
                  ruta: 'catalogoFuncionarios',
                  nombre: 'Funcionarios',
                  scopes: 'Catálogos:ver',
                  icono: 'mdi-folder-download-outline',
                  divisor: false,
                  children: [],
                },
                {
                  ruta: 'catalogoUsuarios',
                  nombre: 'Usuarios',
                  scopes: 'Seguridad:ver',
                  icono: 'mdi-folder-download-outline',
                  divisor: false,
                  children: [],
                },
                {
                  ruta: 'catalogoProgramasInversion',
                  nombre: 'Programas de Inversión',
                  scopes: 'Catálogos:ver',
                  icono: 'mdi-folder-download-outline',
                  divisor: false,
                  children: [],
                },
                {
                  ruta: 'catalogoFuentesFinancieras',
                  nombre: 'Fuentes Financieras',
                  scopes: 'Catálogos:ver',
                  icono: 'mdi-folder-download-outline',
                  divisor: false,
                  children: [],
                },
                {
                  ruta: 'catalogoTiposObra',
                  nombre: 'Tipos de Obra',
                  scopes: 'Catálogos:ver',
                  icono: 'mdi-folder-download-outline',
                  divisor: false,
                  children: [],
                },
                {
                  ruta: 'catalogoSubTiposObra',
                  nombre: 'Sub Tipos de Obra',
                  scopes: 'Catálogos:ver',
                  icono: 'mdi-folder-download-outline',
                  divisor: false,
                  children: [],
                },
                {
                  ruta: 'catalogoEtiquetas',
                  nombre: 'Etiquetas',
                  scopes: 'Catálogos:ver',
                  icono: 'mdi-folder-download-outline',
                  divisor: false,
                  children: [],
                },
                {
                  ruta: 'catalogoContratosEstatus',
                  nombre: 'Contratos Estatus',
                  scopes: 'Catálogos:ver',
                  icono: 'mdi-folder-download-outline',
                  divisor: false,
                  children: [],
                },
                {
                  ruta: 'catalogoExpedientes',
                  nombre: 'Expediente',
                  scopes: 'Catálogos:ver',
                  icono: 'mdi-folder-open',
                  divisor: false,
                  children: [],
                },
              ],
            },
          ],
        },
        // {
        //   ruta: 'infraestructura',
        //   nombre: 'Infrestructura',
        //   scopes: 'Planeación:ver',
        //   icono: 'mdi-office-building',
        //   divisor: false,
        //   children: [],
        // },
        {
          ruta: 'planeacion',
          nombre: 'Planeación',
          scopes: 'Planeación:ver',
          icono: 'mdi-pin',
          divisor: false,
          children: [],
        },
        {
          ruta: 'presupuestos',
          nombre: 'Presupuestos',
          scopes: 'Presupuestos:ver',
          icono: 'monetization_on',
          children: [],
        },
        {
          ruta: 'programacion',
          nombre: 'Programación',
          scopes: 'Programación:ver',
          icono: 'mdi-bank',
          divisor: true,
          children: [
            {
              ruta: 'solicitudesObras',
              nombre: 'Solic. de Autorización',
              scopes: 'Programación:ver',
              icono: 'fa-file-circle-check',
              divisor: false,
              children: [],
            },
            {
              ruta: 'programacion',
              nombre: 'Oficios de Autorización',
              scopes: 'Programación:ver',
              icono: 'fa-money-check-dollar',
              divisor: false,
              children: [],
            },
          ],
        },
        {
          ruta: 'licitaciones',
          nombre: 'Licitaciones',
          scopes: 'Licitaciones:ver',
          icono: 'mdi-book-check-outline',
          divisor: false,
          children: [],
        },
        {
          ruta: 'adjudicaciones',
          nombre: 'Adjudicaciones',
          scopes: 'Adjudicaciones:ver',
          icono: 'mdi-file-check-outline',
          divisor: false,
          children: [],
        },
        {
          ruta: 'contratos',
          nombre: 'Contratos',
          scopes: 'Contratos:ver',
          icono: 'mdi-file-sign',
          divisor: false,
          children: [],
        },
        {
          ruta: 'ejecucion',
          nombre: 'Supervisión',
          scopes: 'Supervisión:ver',
          icono: 'fa-hard-hat',
          contadorQuery: 'supervision',
          divisor: false,
          children: [],
        },
        {
          ruta: 'estimaciones',
          nombre: 'Estimaciones',
          scopes: 'Estimaciones:ver',
          icono: 'fa-file-invoice-dollar',
          divisor: true,
          children: [],
        },
        {
          ruta: 'solicitudes',
          nombre: 'Pagos',
          scopes: 'Pagos:ver',
          icono: 'fa-solid fa-credit-card',
          divisor: true,
          children: [
            {
              ruta: 'solicitudes',
              nombre: 'Solicitudes',
              scopes: 'Pagos:ver',
              icono: 'fa-solid fa-file-invoice',
              divisor: false,
              children: [],
            }, {
              ruta: 'pagos',
              nombre: 'Pagos',
              scopes: 'Pagos:ver',
              icono: 'account_balance_wallet',
              divisor: false,
              children: [],
            },
          ],
        },
        {
          ruta: '',
          nombre: 'Auditorías',
          scopes: 'Auditorias:ver',
          icono: 'mdi-text-box-check-outline',
          divisor: true,
          children: [
            {
              ruta: 'auditorias',
              nombre: 'Registro',
              scopes: 'Auditorías:registro',
              icono: 'mdi-note-edit-outline',
              divisor: false,
              children: [],
            },
            {
              ruta: 'auditoriasSeguimiento',
              nombre: 'Seguimiento',
              scopes: 'Auditorías:seguimiento',
              icono: 'mdi-progress-check',
              divisor: false,
              children: [],
            },
            // {
            //   ruta: 'auditoriasTablero',
            //   nombre: 'Estadisticas',
            //   scopes: 'Pagos:ver',
            //   icono: 'mdi-chart-timeline',
            //   divisor: false,
            //   children: [],
            // },
          ],
        },
        {
          ruta: 'consultasEstatusContratos',
          nombre: 'Consultas',
          scopes: 'Consultas:ver',
          icono: 'fa-file-alt',
          divisor: false,
          children: [],
        },
        {
          ruta: 'mapaObras',
          nombre: 'Mapa',
          scopes: '',
          icono: 'mdi-map',
          divisor: false,
          children: [],
        },
      ],
    };
  },
  apollo: {
    getNumberContratosWithObservacionesActivas: {
      query: GET_CONTRATOS_CON_OBSERVACIONES,
    },
  },
  methods: {
    mostrarOcultarMenu() {
      this.mostrar = !this.mostrar;
    },
    usuarioTieneScopes(rutaScopes) {
      if (rutaScopes === '') { return false; }
      if (Array.isArray(this.getScopes)) {
        if (!this.getScopes.includes(rutaScopes)) { return true; }
      }
      return false;
    },
    obtenerNumeroContratosConObservaciones() {
      return this.getNumberContratosWithObservacionesActivas;
    },
  },
  mounted() {
    eventBus.$on('mostrar-ocultar-menu', () => {
      this.mostrarOcultarMenu();
    });
  },
  computed: {
    getScopes() {
      if (!this.$auth.user) { return ['']; }
      return this.$auth.user.scopes;
    },

  },

};
</script>

<style lang="scss">
</style>
